// Contains the code for summoning the Freshdesk chat widget, and passing in the customer's information
// to the freshdesk dashboard.

import { Vue, Component, Prop, toNative } from "vue-facing-decorator";
import { loadScript } from "vue-plugin-load-script";
import { MiaPlaza } from "@/Reinforced.Typings";
import type { VNode } from "vue";

@Component
export class Freshdesk extends Vue {
	@Prop({ required: false, default: null }) private freshdeskKey!: string | null;
	@Prop({ required: false, default: null }) private freshdeskWidgetUuid!: string | null;
	@Prop({ type: Object, required: true }) private userData!: MiaPlaza.Control.Vue.IUserData;

	async created() {
		// We deliberately allow for values of null to disable the widget in scenarios we don't want
		// it to be enabled (for example, on dev environments)
		if (!this.freshdeskKey) {
			return;
		}

		await loadScript("https://wchat.freshchat.com/js/widget.js");
		(window as any).fcWidget.init({
			token: this.freshdeskKey,
			host: "https://wchat.freshchat.com",
			widgetUuid: this.freshdeskWidgetUuid,
			firstName: this.userData.FirstName,
			lastName: this.userData.LastName,
			email: this.userData.Email,
			config: {
				showFAQOnOpen: false,
				hideFAQ: true,
				headerProperty: {
					direction: "ltr",
				},
			},
		});
	}

	protected render(): VNode[] | undefined {
		return undefined;
	}
}

export default toNative(Freshdesk);
